'use client'

import Cards from '@/ui/assets/components/cards.inline.svg'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { CheckCircle2, Sparkles } from 'lucide-react'

export function CardKYCSuccess() {
  return (
    <div className="flex flex-col items-center gap-12 lg:flex-row lg:items-start">
      <div className="flex flex-1 flex-col gap-6">
        <Panel.Wrapper className="relative w-full max-w-xl overflow-hidden">
          <div className="pointer-events-none absolute inset-0 rounded-lg bg-gradient-to-br from-green-500/15 via-transparent to-primary/15" />

          <Panel.Content className="relative flex flex-col items-center gap-6 p-8 text-center">
            <div className="relative">
              <div className="flex h-20 w-20 animate-bounce items-center justify-center rounded-full border-2 border-green-500/30 bg-green-500/10">
                <CheckCircle2 className="h-10 w-10 text-green-400" />
              </div>
              <Sparkles className="-top-2 -right-2 absolute h-6 w-6 animate-pulse text-gradient-yellow" />
              <Sparkles className="-bottom-1 -left-3 absolute h-5 w-5 animate-pulse text-primary delay-300" />
            </div>

            <div className="flex flex-col gap-2">
              <Typography variant="h3" gradient>
                Verification Submitted!
              </Typography>
              <Typography variant="p" className="text-muted-foreground">
                Great job! Your identity verification has been submitted and is now being processed. This typically takes
                1-2 business days.
              </Typography>
            </div>

            <div className="flex w-full flex-col gap-3 rounded-lg border border-green-500/20 bg-green-500/5 p-4">
              <div className="flex items-center justify-center gap-2">
                <Sparkles className="h-4 w-4 text-green-400" />
                <Typography variant="p" className="font-medium text-green-400 text-sm">
                  We&apos;ll check your status automatically
                </Typography>
              </div>
              <Typography variant="p" className="text-muted-foreground text-xs">
                No need to keep refreshing — your status will be updated in the background.
              </Typography>
            </div>

            <div className="flex items-center gap-2 pt-2">
              <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary" />
              <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary delay-150" />
              <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary delay-300" />
              <Typography variant="p" className="text-muted-foreground text-xs">
                Loading status details...
              </Typography>
            </div>
          </Panel.Content>
        </Panel.Wrapper>
      </div>

      <div className="relative flex items-center justify-center lg:flex-1">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-[250px] w-[350px] rounded-full bg-gradient-to-br from-green-500/15 to-primary/15 blur-[60px]" />
        </div>
        <div className="relative drop-shadow-[0_0_40px_rgba(74,222,128,0.2)] transition-transform duration-500 hover:scale-105">
          <Cards className="h-auto w-full max-w-sm" />
        </div>
      </div>
    </div>
  )
}
